module.exports = __webpack_public_path__ + "static/media/cart.da86452c.svg";